<template>
  <div class="partsInventoryHistory-bd tb">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 导出excel -->
        <el-form-item style="float: right; margin-right: 0">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable"><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.codeName" :placeholder="$t('fms_partsInventoryHistory.pei_jian')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <el-input v-model="formSearch.afterServiceName" clearable :placeholder="$t('fms_partsInventoryHistory.shou_hou_gong_si')" @clear="onPageChange({ page: 1 })"></el-input>
        </el-form-item>
        <el-form-item style="float: right">
          <el-input v-model="formSearch.search" clearable :placeholder="$t('fms_partsInventoryHistory.ji_shen_hao')" @clear="onPageChange({ page: 1 })"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table :slots="['deliveryBatchNum']" height="100%" index :data="tableList" tableCode="partsInventoryHistory" @sort="sortChange" @filter="filterChange" @column="setColumn">
        <template v-slot:deliveryBatchNum="scope">
          <span class="cell-link" @click.stop="showDetail(scope.row)">{{ scope.row.deliveryBatchNum }}</span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>

    <part-order-detail-dialog v-if="detailVisible" @close="detailVisible = false" :model="detailModel" @infoChange="infoChangeHandler"></part-order-detail-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import mixins from '@/pages/crm/freeAccessoriesOrder/children/mixins.js';
import partOrderDetailDialog from '@/pages/crm/components/part_order_detail_dialog.vue';

export default {
  name: 'partsInventoryHistory',
  mixins: [mixins],
  components: {
    partOrderDetailDialog,
  },
  data() {
    return {
      type: 1,
      formSearch: {
        codeName: '',
        afterServiceName: '',
        search: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableList: [],
      totalRows: null,
      // 配送订单详情
      detailVisible: false,
      detailModel: {},
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);

    this.getFuncView();
    this.getTableList();
  },
  methods: {
    // 配送订单详情
    showDetail(row) {
      this.detailModel = {
        title: row.orderGoodsCode,
        data: row,
      };
      this.detailVisible = true;
    },
    onTabChange(value) {
      this.type = value;
    },
    getTableList() {
      this.$getJSON(apis.giveawayBalanceRecordPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    exportTable: function () {
      this.$exportFlie(apis.giveawayBalanceRecordExport, this.formSearch).then(() => {});
    },
  },
};
</script>

<style lang="scss">
.partsInventoryHistory-bd {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.rest-record-item {
  .tab {
    margin-left: -16px;
    margin-right: -16px;
  }

  .half-content {
    width: 25%;
    display: inline-block;
  }

  .half-width {
    width: 50% !important;
  }

  .underline {
    color: #0d9ae0;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
